import { type ShallowRef, shallowRef } from "vue";

export const ALLOWED_FILE_TYPES = [
  "video/*",
  ".heic",
  ".xbm",
  ".jpg",
  ".jpeg",
  ".png",
  ".tif",
  ".pjp",
  ".tiff",
  ".jfif",
  ".webp",
  ".bmp",
  ".pjpeg",
  "image/jpeg",
];

/** Files picked before the form could take them; the form empties it. */
export const pickedFiles: ShallowRef<File[]> = shallowRef([]);

/**
 * Opens the file picker straight from a photo button's click. Browsers only
 * allow that during the click, before the sidebar has loaded the form.
 */
export function openMediaPicker(): void {
  const input = document.createElement("input");

  input.type = "file";
  input.multiple = true;
  input.accept = ALLOWED_FILE_TYPES.join(",");
  input.addEventListener("change", () => {
    pickedFiles.value = Array.from(input.files || []);
  });
  input.click();
}

export function takePickedFiles(): File[] {
  const files = pickedFiles.value;

  if (files.length) {
    pickedFiles.value = [];
  }
  return files;
}
